<script>
  import * as $vestibularService from '../../services/vestibularService'

  import bus from '@utils/bus'
  import helpers from '@mixins/helper'
  import {set, get} from '@utils/storage'

  import {required, minLength} from 'vuelidate/lib/validators'
  import {cloneDeep} from 'lodash'

  const opcoesDefault = [
    {
      opcao: 1,
      ref_campus: '',
      ref_oferta_curriculo: '',
      ref_curriculo: '',
      cursos: [],
      curso: '',
      campus: '',
      link: ''
    },
    {
      opcao: 2,
      ref_campus: '',
      ref_oferta_curriculo: '',
      ref_curriculo: '',
      cursos: [],
      curso: '',
      campus: '',
      link: ''
    },
    {
      opcao: 3,
      ref_campus: '',
      ref_oferta_curriculo: '',
      ref_curriculo: '',
      cursos: [],
      curso: '',
      campus: '',
      link: ''
    }
  ]

  export default {
    mixins: [helpers],
    props: ['valido'],
    data () {
      return {
        form: {
          ref_local_prova: '',
          local_prova: ''
        },
        opcoes: cloneDeep(opcoesDefault),
        cursos: [],
        campus: [],
        locais: [],
        cursoSelect: [],
        data: []
      }
    },
    validations: {
      form: {
        ref_local_prova: {required}
      },
      opcoes: {
        required,
        minLength: minLength(3),
        $each: {
          ref_campus: {required},
          ref_oferta_curriculo: {required}
        }
      }
    },
    async mounted () {
      this.data = await get('form')
      await this.carregarDados()
      bus.$emit('hide-loader')
    },
    watch: {
      '$v.opcoes.$invalid': {
        handler: function (value) {
          this.$emit('update:valido', !value)
        },
        deep: true
      }
    },
    methods: {
      async carregarDados () {
        // const opcoes = await get('opcoes')
        const curriculos = await $vestibularService.buscarCurriculos(this.data)
        this.cursos = [...curriculos]
        this.cursos.forEach(curso => {
          let campus = this.campus.find(campus => campus.id === curso.ref_campus)
          if (!campus) {
            this.campus.push({id: curso.ref_campus, descricao: curso.campus})
          }
        })
        /*
        this.opcoes = [...opcoes]
        this.opcoes.forEach((item, index) => {
          this.selecionaCampus(item.ref_campus, item)
          this.selecionaOpcao(index)
        })
        */
        const locais = await $vestibularService.buscarLocaisProva(this.data.ref_processo_seletivo)
        this.locais = [...locais]
        // this.organizaCursos()
      },
      buscarCurso (id) {
        return this.cursos.find(item => item.ref_oferta_curriculo === id)
      },
      async selecionaLocal () {
        let form = {...await get('form')}
        form.ref_local_prova = this.form.ref_local_prova
        if (this.form.ref_local_prova) {
          const local = this.locais.find(item => item.ref_local_prova === this.form.ref_local_prova)
          form.local_prova = local.cidade
        }
        await set('form', form)
      },
      async selecionaCampus (opcao) {
        opcao.cursos.splice(0)
        if (opcao.ref_campus) {
          opcao.cursos = this.cursos.filter(item => item.ref_campus === opcao.ref_campus)
          if (opcao.opcao === 1) {
            const quantidadeOpcoes = this.opcoes.length
            for (let i = 1; i < quantidadeOpcoes; i++) {
              if (quantidadeOpcoes > i && !this.opcoes[i].ref_campus) {
                this.opcoes[i].ref_campus = opcao.ref_campus
              }
            }
          }
        }
      },
      async selecionaOpcao (opcao) {
        if (opcao.ref_oferta_curriculo) {
          let curso = this.buscarCurso(opcao.ref_oferta_curriculo)
          let campus = this.campus.find(item => item.id === opcao.ref_campus)
          if (curso && campus) {
            opcao.curso = curso.curso
            opcao.campus = campus.descricao
            opcao.link = 'https://urcamp.edu.br/cursos/graduacao/' + curso.curso_slug
          }
        }
        this.organizaCursos(opcao)
      },
      organizaCursos (opcao) {
        let opcoes = this.opcoes.filter(item => item.opcao !== opcao.opcao)
        opcoes.forEach(item => {
          item.cursos = this.cursos.filter(curso => curso.ref_campus === opcao.ref_campus)
            .filter(curso => curso.ref_oferta_curriculo !== opcao.ref_oferta_curriculo)
        })
        set('opcoes', this.opcoes)
      },
      async limparSelecaoCampus () {
        this.opcoes.forEach((opcao, index) => {
          if (opcao.ref_campus === null || this.form.ref_local_prova === null) {
            if (this.form.ref_local_prova === null) {
              opcao.ref_campus = null
            }
            opcao.ref_oferta_curriculo = null
            this.opcoes.$each[index].ref_oferta_curriculo.$touch()
          }
        })
      },
      async localProvaAlterado () {
        this.selecionaLocal()
        this.limparSelecaoCampus()
      }
    }
  }

</script>
<template>
    <v-layout row wrap>
        <v-flex xs12>
            <h4 class="title">Selecione local de realização da prova</h4>
        </v-flex>
        <v-flex xs12>
            <v-form>
                <v-layout row wrap>
                    <v-flex class="mt-2" xs12>
                        <v-autocomplete color="amber darken-3"
                                        :items="locais"
                                        v-model="form.ref_local_prova"
                                        label="Local da Prova"
                                        item-text="descricao"
                                        item-value="ref_local_prova"
                                        @change="localProvaAlterado"
                                        :error-messages="validationMessageField($v.form.ref_local_prova)"
                                        @input="$v.form.ref_local_prova.$touch()"
                                        @blur="$v.form.ref_local_prova.$touch()"
                                        clearable>
                        </v-autocomplete>
                    </v-flex>
                </v-layout>
                <v-divider class="my-2"></v-divider>
                <v-flex v-if="form.ref_local_prova" xs12>
                    <h4 class="title">Selecione quais cursos deseja se candidatar</h4>
                </v-flex>
                <v-card v-if="form.ref_local_prova" v-for="(item,index) in opcoes">
                    <v-layout row wrap>
                        <v-flex xs12>
                            <v-subheader class="pa-0"><strong>{{item.opcao}}ª Opção de Curso</strong></v-subheader>
                        </v-flex>
                        <v-flex class="input-opcao pr-2" xs12 sm4>
                            <v-autocomplete color="amber darken-3"
                                            :items="campus"
                                            v-model="item.ref_campus"
                                            label="Campus"
                                            item-text="descricao"
                                            item-value="id"
                                            @change="selecionaCampus(item)"
                                            :error-messages="validationMessageField($v.opcoes.$each[index].ref_campus)"
                                            @input="$v.opcoes.$each[index].ref_campus.$touch()"
                                            @blur="$v.opcoes.$each[index].ref_campus.$touch()"
                                            clearable>
                            </v-autocomplete>
                        </v-flex>

                        <v-flex class="input-opcao" xs12 sm8>
                            <v-autocomplete color="amber darken-3"
                                            :disabled="!item.ref_campus"
                                            :items="item.cursos"
                                            v-model="item.ref_oferta_curriculo"
                                            label="Cursos"
                                            item-text="curso"
                                            item-value="ref_oferta_curriculo"
                                            @change="selecionaOpcao(item)"
                                            :error-messages="validationMessageField($v.opcoes.$each[index].ref_oferta_curriculo)"
                                            @input="$v.opcoes.$each[index].ref_oferta_curriculo.$touch()"
                                            @blur="$v.opcoes.$each[index].ref_oferta_curriculo.$touch()"
                                            clearable>
                            </v-autocomplete>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap v-if="item.ref_oferta_curriculo">
                        <v-flex xs12>
                            <v-card class="box-informacoes ma-1">
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-subheader class="pa-0 pl-2 title-informacoes">
                                            Informaçoes do curso
                                            {{ buscarCurso(item.ref_oferta_curriculo).curso }}
                                        </v-subheader>
                                    </v-flex>
                                    <v-flex class='pb-3 pl-2' xs12 sm4>
                                        <strong>Carga Horária:</strong>
                                        <span class="informacao">
                                            {{ buscarCurso(item.ref_oferta_curriculo).carga_horaria_min }} Horas
                                        </span>
                                    </v-flex>
                                    <v-flex class='pb-3 pl-2' xs12 sm4>
                                        <strong>Turno:</strong>
                                        <span class="informacao">
                                            {{ buscarCurso(item.ref_oferta_curriculo).turno }}
                                        </span>
                                    </v-flex>
                                    <v-flex class='pb-3 pl-2' xs12 sm4>
                                        <strong>Duração:</strong>
                                        <span class="informacao">
                                            {{ buscarCurso(item.ref_oferta_curriculo).total_semestres }} Semestres
                                        </span>
                                    </v-flex>
                                    <v-flex xs12 text-xs-right class="ma-1">
                                        <a target="_blank" :href="item.link">Mais Informações clique aqui</a>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-form>
        </v-flex>
    </v-layout>
</template>
<style lang="scss">
    .box-informacoes {
        background-color: #F4F6EF !important;

        .title-informacoes {
            color: #68733B !important;
        }

        .informacao {
            color: #326981 !important;
        }
    }
</style>




// WEBPACK FOOTER //
// SelecaoCursos.vue?14dac196